<script setup>
import { BAccordion, BAccordionItem, BLink, BTable } from 'bootstrap-vue-next';
import { ref } from 'vue';

import UserWithGitLabProfileLink from '~/common/components/UserWithGitLabProfileLink.vue';

import PastContributorModal from './PastContributorModal.vue';

defineProps({
  releases: {
    type: Array,
    required: true,
  },
});

const selectedRelease = ref(null);
const showModal = ref(false);

const fields = [
  { key: 'release', label: 'Release', tdClass: 'text-nowrap' },
  { key: 'contributors', label: 'Contributors', tdClass: 'text-nowrap' },
  { key: 'summary', label: 'Summary' },
];

const hasWriteUp = (release) => {
  return Boolean(release.writeUp);
};

const openRelease = (event) => {
  const release = event.item;

  if (!hasWriteUp(release)) {
    return;
  }

  selectedRelease.value = release;
  showModal.value = true;
};
</script>

<template>
  <BAccordion
    class="accordion-table mb-2 mt-2"
  >
    <BAccordionItem
      title="Previous Notable Contributors"
      :visible="true"
    >
      <BTable
        :items="releases"
        :fields="fields"
        hover
        responsive
        tbody-tr-class="cursor-pointer"
        @row-clicked="openRelease"
      >
        <template #cell(release)="{ item }">
          <BLink
            v-if="item.releasePostUrl"
            :href="item.releasePostUrl"
            target="_blank"
            class="text-decoration-none"
            @click.stop
          >
            {{ item.release }}<br>{{ item.date }}
          </BLink>
          <span v-else>{{ item.release }}<br>{{ item.date }}</span>
        </template>

        <template #cell(contributors)="{ value }">
          <div
            v-for="contributor in value"
            :key="contributor.gitlabUsername || contributor.name"
            @click.stop
          >
            <UserWithGitLabProfileLink
              v-if="contributor.gitlabUsername"
              :username="contributor.gitlabUsername"
            />
            <span v-else>{{ contributor.name }}</span>
          </div>
        </template>

        <template #cell(summary)="{ item }">
          <span class="text-muted small summary-clamp">
            {{ item.writeUp || '' }}
          </span>
        </template>
      </BTable>

      <PastContributorModal
        v-model="showModal"
        :release="selectedRelease"
      />
    </BAccordionItem>
  </BAccordion>
</template>
